"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = __importDefault(require("./config"));

function storage(context, options) {
  var _config_1$default = config_1.default(options),
      STORAGE_ENDPOINT = _config_1$default.STORAGE_ENDPOINT;

  var shop = context.auth.shop;
  var shopId = shop.id;

  function upload(file, dir) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var formdata, request, response, _yield$response$json, token, results;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                formdata = new FormData();
                if (typeof dir === 'string') formdata.append('dir', dir);
                formdata.append('file', file);
                request = {
                  method: 'post',
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-shop-id': context.auth.shop.id
                  },
                  body: formdata
                };
                _context.next = 7;
                return fetch("".concat(STORAGE_ENDPOINT, "/upload"), request);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.json();

              case 10:
                _yield$response$json = _context.sent;
                token = _yield$response$json.token;
                results = "".concat(STORAGE_ENDPOINT, "/download/").concat(token, "?shop_id=").concat(shopId);
                resolve(results);
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 16]]);
      }));
    });
  }

  return {
    upload: upload
  };
}

exports.default = storage;